import img1 from '../../../images/slider1.png'
import img2 from '../../../images/slider2.png'
import img3 from '../../../images/slider3.png'

const dataSlider = [
    {
      img: img1,
      id: 1,
      title: "Internships may not require physical strength, but initiative definitely does"
    },
    {
      img: img2,
      id: 2,
      title: "Grow through what you go through!!"
    },
    {
      img: img3,
      id: 3,
      title: "Your one-step solution for your jobs and intership related queries"
    },
    
  ];
  
  export default dataSlider;